import React, { useState } from 'react';
import CommonConfigDialog from './CommonConfigDialog';
import { RequiredDialogInput, RequiredDialogSelect, DialogCheckbox } from '../../DialogInputs';
import { handleInputChange } from '../../Utilities/DialogUtils';
import { useHttpUtils } from '../../Utilities/useHttpUtils';

function EquipmentTypeEditDialog({ dialogData, setDialogData, showDialog, closeDialog, businessUnits }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [fieldErrors, setFieldErrors] = useState({});

    const saveEquipmentType = (equipmentType) => {

        let promise = new Promise((resolve, reject) => {
            let url = `api/v1/equipmenttype`;
            if (equipmentType.equipmentTypeId != null) {
                url += `/${equipmentType.equipmentTypeId}`
            }
            
            fetchDataAuthenticated(url, "POST", JSON.stringify(equipmentType))
                .then(response => response.json())
                .then(data => {
                    if (data.errors !== null && data.errors !== undefined) {
                        reject(data);
                    }
                    resolve(data);
                })
                .catch(error => {
                    alert("There was a problem! " + error);
                });

        });

        return promise;
    };

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }
    
    return (
        <CommonConfigDialog title={"Equipment Type - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveEquipmentType} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors}>
            <RequiredDialogInput controlId="formEquipmentTypeName" title="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <RequiredDialogSelect controlId="formEquipmentTypeBusinessUnit" title="Business Unit" name="businessUnitId" value={dialogData.businessUnitId} error={fieldErrors.businessUnitId} onChange={onChange}>
                <option value="" key={0} >Please Select...</option>
                {businessUnits.map((bu) => <option value={bu.businessUnitId} key={bu.businessUnitId}>{bu.name}</option>)}
            </RequiredDialogSelect>
            <DialogCheckbox disabled={dialogData.equipmentTypeId === null} controlId="formEquipmentTypeIsDeleted" title="Deleted?" name="isDeleted" checked={dialogData.isDeleted} error={fieldErrors.isDeleted} onChange={onChange} /> 
        </CommonConfigDialog>
    );
}

export default EquipmentTypeEditDialog;